import Seo from "@/components/Seo";
import Reveal from "@/components/Reveal";
import Marquee from "@/components/Marquee";
import { overline } from "@/components/kit";
import { CITY_DATA, CITY_IMAGES } from "@/data/cities";
import { CityProjects, CityCTA } from "@/components/CityShared";
import CityLocalBusinessJsonLd from "@/components/CityLocalBusinessJsonLd";

// LILLE — Typographic marquee heavy
export default function CityLille() {
  const c = CITY_DATA.lille;
  return (
    <>
      <Seo title={`Événementiel à ${c.name}`} description={c.seoDesc} path="/villes/lille" />
      <CityLocalBusinessJsonLd city={c} />
      <section className="pt-32 md:pt-40">
        <h1 className="sr-only">Agence événementielle B2B à {c.name}</h1>
        <Reveal><div className="px-5 md:px-10"><span className={overline}>{c.region}</span></div></Reveal>
        <div className="mt-6 overflow-hidden border-y border-ink/10 bg-lime py-4 text-ink">
          <Marquee items={[c.name, c.name, c.name]} className="font-serif text-[22vw] font-medium italic leading-none md:text-[16vw]" />
        </div>
        <Reveal delay={1}><p className="mx-auto mt-12 max-w-3xl px-5 text-center font-serif text-3xl leading-snug text-ink md:text-4xl">{c.tagline}</p></Reveal>
      </section>

      <section className="mx-auto max-w-[1440px] px-5 py-16 md:px-10 md:py-24">
        <div className="grid items-center gap-12 md:grid-cols-2">
          <Reveal><div className="overflow-hidden rounded-2xl"><img src={CITY_IMAGES.conf} alt={c.name} className="aspect-[4/3] w-full object-cover" /></div></Reveal>
          <div>
            <Reveal><p className="text-xl leading-relaxed text-ink/75">{c.intro}</p></Reveal>
            {c.body.map((p, i) => (<Reveal key={i} delay={i + 1}><p className="mt-6 text-lg leading-relaxed text-ink/60">{p}</p></Reveal>))}
          </div>
        </div>
        <div className="mt-20 grid gap-4 md:grid-cols-3">
          {c.highlights.map((h, i) => (
            <Reveal key={i} delay={i}>
              <div className="rounded-2xl border border-ink/10 bg-mist p-8"><span className="font-serif text-5xl text-lime-dim/40">0{i + 1}</span><h3 className="mt-4 font-serif text-2xl text-ink">{h.k}</h3><p className="mt-3 text-sm text-ink/55">{h.v}</p></div>
            </Reveal>
          ))}
        </div>
      </section>

      <div className="border-y border-ink/10 bg-lime py-4 text-ink"><Marquee items={c.quartiers} className="font-serif text-3xl italic md:text-4xl" speed="fast" /></div>

      <CityProjects city={c.name} />
      <CityCTA city={c.name} />
    </>
  );
}
